import { useState, useEffect } from 'react';
import './servicesCard.css';
import Actionbutton from 'components/elements/buttons/button';

const ServicesCardStack = () => {

    const servicesList = [
        { title: 'Startups & Growth', color: "text-orange" },
        { title: 'Asset Financing', color: "text-brown" },
        { title: 'Invoice Discount', color: "text-secondary" },
        { title: 'Working Capital', color: "text-text-color" }];

    const [index, setIndex] = useState(0);

    useEffect(() => {
        const interval = setTimeout(() => {
            setIndex((prevIndex) => (prevIndex + 1) % servicesList.length);
        }, 4000);

        return () => clearTimeout(interval);
    }, [index,  servicesList.length]);


    return (
        <section class="services_card my-14 px-6 lg:px-20">
            <ul id="cards flex flex-col items-center justify-center">
                <li class="card bg-light-pink-1  bg-service-pattern flex flex-col lg:flex-row lg:space-x-48 py-6 lg:py-14 px-8 lg:px-14 rounded-lg " id="card1">
                    <div className="service-title basis-full lg:basis-11/12 text-text-color pt-1 lg:pt-8">
                        {/* <h1 className="text-2xl lg:text-5xl text-text-color lg:leading-none tracking-normal text-orange font-semibold">We offer Loans that
                            <br className='display-none lg:inline'></br>Power  <span className={`font-serif italic ${servicesList[index].color}  font-semibold leading-normal`}>{servicesList[index].title}</span></h1> */}

                             <h1 className="text-2xl lg:text-5xl text-text-color tracking-normal text-orange font-semibold">We Fund her <br></br>
                            <span className="font-serif italic text-secondary font-semibold leading-normal">Dreams and Vision</span> </h1>
                        <p className="pt-2 pb-4 lg:pt-2 lg:pb-8 text-dark-grey text-sm lg:text-base text-justify font-medium">Starting or growing a business as a woman in Africa can be tough — but money shouldn’t hold you back. That’s why we offer affordable, interest-friendly loans built to help you rise. We offer loans that support growth, asset financing, Invoice discount, and working capital.</p>

                        <Actionbutton to={"/loan"} text={"Take a Loan"} fontsize='text-normal' horzpadding='pt-2 pb-2 lg:py-4 px-8 lg:px-16'  textcolor='text-secondary' background='light-pink-1' outline='secondary'/>
                    </div>
                    <div className="mt-4 px-2 lg:px-10 pt-4 rounded-t-full bg-light-orange-1 flex lg:items-end place-content-center">
                        <img
                            src="https://shecluded-medias.s3.us-east-2.amazonaws.com/hero-service-1.svg"
                            alt="illustration of woman holding money"
                            className="w-full lg:w-[430px] object-cover rounded-lg"
                        />
                    </div>
                </li>
                <li class="card bg-light-purple bg-service-pattern flex flex-col lg:flex-row lg:space-x-48 py-6 lg:py-14 px-8 lg:px-14 rounded-lg " id="card2">
                    <div className="service-title basis-full lg:basis-11/12 text-text-color pt-1 lg:pt-8">
                    <h1 className="text-2xl lg:text-5xl text-text-color lg:max-w-lg  tracking-normal font-semibold">
                                 We Grow her Business from <span className="font-serif italic text-primary font-semibold leading-normal"> Idea to Impact</span></h1>
                                
                                <p className="pt-2 pb-4 lg:pt-2 lg:pb-8 text-dark-grey text-base text-justify font-medium">Through our incubator and accelerator programs, we support women with game-changing ideas. You’ll get expert mentorship, coaching, business tools, and the chance to pitch your solution.  And if you shine? You walk away with grant funding to bring your vision to life.</p>
                                <Actionbutton to={"/hub"} text={"Join our Programs"} fontsize='text-normal' horzpadding='py-2 lg:py-4 px-10 lg:px-16' textcolor='text-primary' background='light-purple ' outline='primary' />
                    </div>
                    <div className="mt-4 px-2 lg:px-10 pt-10 lg:pt-24 rounded-t-full  bg-primary-light-2  flex lg:items-end place-content-center">
                        <img
                            src="https://shecluded-medias.s3.us-east-2.amazonaws.com/hero-service-2.svg"
                                    alt="illustration of woman in orange facecap smiling"
                            className="w-full lg:w-[430px] object-cover rounded-lg"
                        />
                    </div>
                </li>
                <li class="card bg-light-green-2 bg-service-pattern flex flex-col lg:flex-row lg:space-x-48 py-6 lg:py-14 px-8 lg:px-14 rounded-lg " id="card3">
                    <div className="service-title basis-full lg:basis-11/12 text-text-color pt-1 lg:pt-8">
                    <h1 className="text-2xl lg:text-5xl text-text-color lg:max-w-sm tracking-normal font-semibold">We Create her<span className="font-serif italic text-light-green-8 font-semibold"> Co-work Space 
                                 </span> </h1>
                                <p className="pt-2 pb-4 lg:pt-6 lg:pb-8 text-dark-grey text-base text-justify font-medium">Every queen needs her castle. Our Shecluded Hub is a welcoming co-working space where you can work, meet, and build your dream.Need a business address? Need quiet focus time or a place to pitch investors? We’ve got you.</p>

                                <Actionbutton to={"/hub"} text={"Book a Space"} fontsize='text-normal' horzpadding='py-2 lg:py-4 px-10 lg:px-16'  textcolor='text-light-green-8' background='bg-light-green-2'/>
                    </div>
                    <div className="mt-4 px-2 lg:px-10 pt-4 lg:pt-14 rounded-t-full   bg-light-green-3  flex lg:items-end place-content-center">
                        <img
                          src="https://shecluded-medias.s3.us-east-2.amazonaws.com/hero-service-3.svg"
                                    alt="illustration of wearing hijab smiling"
                            className="w-full lg:w-[430px] object-cover rounded-lg"
                        />
                    </div>
                </li>
            </ul>
        </section>
    );
};

export default ServicesCardStack;
